import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MachinesService } from 'src/app/_services/machines.service';
import { MessService } from 'src/app/_services/mess-service.service';

@Component({
  selector: 'app-machins-edit',
  templateUrl: './machins-edit.component.html',
  styleUrls: ['./machins-edit.component.scss'],
})
export class MachinsEditComponent implements OnInit, OnDestroy {
  form: FormGroup;
  machineForUpdate: any;
  subscriptions: Subscription[] = [];
  allOperations = [];
  selectedOpterations = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private machineService: MachinesService,
    private messService: MessService,
    private fb: FormBuilder
  ) {
    /**
     * Get all operations
     */
    this.subscriptions.push(
      this.machineService.getAllOperations().subscribe((res) => {
        this.allOperations = res;
      })
    );
  }

  /* ====================================
  *              LIFECYCLES
  ======================================= */
  ngOnInit(): void {
    this.form = this.fb.group({
      name: [''],
      code: [''],
      serial_number: [''],
      operations: [],
    });

    this.subscriptions.push(
      this.machineService.updateMachineData.subscribe((responseData: any) => {
        if (!responseData) {
          this.router.navigate(['./../'], { relativeTo: this.route });
          return;
        }
        this.machineForUpdate = responseData;

        this.patchForm();
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
  *             MAIN FEATURES
  ======================================= */
  addOperatios(event, field) {
    this.form.patchValue({
      [field]: event.value,
    });
  }

  onSubmit() {
    let operationsArray = this.form.get('operations').value;
    let formData = this.form.getRawValue();

    /**
     * Change operations array from array to object with key "id"
     */
    operationsArray.forEach((element, index) => {
      const obj = {};
      obj['id'] = element;
      this.selectedOpterations.push(obj);
    });

    this.form.patchValue({
      operations: this.selectedOpterations,
    });

    formData = this.form.getRawValue();

    this.machineService
      .updateMachine(this.machineForUpdate.id, formData)
      .subscribe(
        () => {
          this.messService.add({
            severity: 'success',
            title: 'Uspešno ažuriranje',
            detail: 'Ažurirali ste masinu.',
          });
          this.router.navigate(['./../'], { relativeTo: this.route });
        },
        (error) => {
          const errorObj = error.error.errors;
          const form = this.form;
          const messService = this.messService;

          Object.keys(errorObj).forEach(function (key) {
            const formControl = form.get(key);
            if (formControl) {
              // If error exist set red border to field
              formControl.setErrors({});
            }
            // Push toast error for every field
            messService.addError({
              severity: 'error',
              title: 'Greška',
              detail: errorObj[key],
              sticky: true,
            });
          });
        }
      );
  }

  /* ====================================
  *                HELPERS
  ======================================= */
  patchForm() {
    let operationsArray = [];
    this.machineForUpdate.operations.forEach((operation) => {
      operationsArray.push(operation.id);
    });

    this.form.patchValue({
      name: this.machineForUpdate?.name,
      operations: operationsArray,
      serial_number: this.machineForUpdate?.serial_number,
      code: this.machineForUpdate?.code,
    });
  }
}
